import {
  BarChart3,
  Gift,
  Home,
  KeyRound,
  Landmark,
  Menu,
  ReceiptText,
  ScrollText,
  ShieldCheck,
  Store,
  Webhook,
} from 'lucide-react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { db } from '../firebase';

const NAV_GROUPS = [
  {
    label: 'Dashboard',
    items: [
      { to: '/', icon: Home, label: 'Overview', end: true },
      { to: '/merchants', icon: Store, label: 'Merchants' },
      { to: '/analytics', icon: BarChart3, label: 'Analytics' },
      { to: '/operations', icon: ShieldCheck, label: 'Operations', badgeKey: 'pendingApprovals' },
    ],
  },
  {
    label: 'Integrations',
    items: [
      { to: '/integrations/webhooks', icon: Webhook, label: 'Webhooks' },
      { to: '/integrations/whatsapp-bot', icon: ReceiptText, label: 'WhatsApp Bot', badgeKey: 'failedTasks' },
      { to: '/integrations/api-keys', icon: KeyRound, label: 'API Keys' },
    ],
  },
  {
    label: 'Admin',
    items: [
      { to: '/promo-codes', icon: Gift, label: 'Promo Codes' },
      { to: '/gst-master', icon: Landmark, label: 'GST Master', badgeKey: 'reviewQueue' },
      { to: '/audit-log', icon: ScrollText, label: 'Audit Log' },
      { to: '/admin-users', icon: ShieldCheck, label: 'Admin Users' },
    ],
  },
];

function useNavBadges() {
  const [badges, setBadges] = useState({ pendingApprovals: 0, failedTasks: 0, reviewQueue: 0 });

  useEffect(() => {
    const unsubscribers = [
      onSnapshot(query(collection(db, 'adminTasks'), where('status', '==', 'pending_approval')), (snap) => {
        setBadges((current) => ({ ...current, pendingApprovals: snap.size }));
      }, () => {}),
      onSnapshot(query(collection(db, 'adminTasks'), where('status', '==', 'failed')), (snap) => {
        setBadges((current) => ({ ...current, failedTasks: snap.size }));
      }, () => {}),
      onSnapshot(collection(db, 'gstReviewQueue'), (snap) => {
        setBadges((current) => ({ ...current, reviewQueue: snap.size }));
      }, () => {}),
    ];
    return () => unsubscribers.forEach((unsubscribe) => unsubscribe());
  }, []);

  return badges;
}

export default function Sidebar({ collapsed, onToggle }) {
  const badges = useNavBadges();

  return (
    <aside className={`wb-sidebar ${collapsed ? 'is-collapsed' : ''}`}>
      <div className="wb-brand-wrap">
        <div>
          <div className="wb-brand">WorkBill Admin</div>
          <div className="wb-brand-sub">admindash.workbill.in</div>
        </div>
        <button type="button" className="wb-sidebar-toggle" aria-label="Toggle sidebar" onClick={onToggle}>
          <Menu size={18} />
        </button>
      </div>
      <nav>
        {NAV_GROUPS.map((group) => (
          <div className="wb-nav-group" key={group.label}>
            <p className="wb-nav-group-title">{group.label}</p>
            {group.items.map((item) => {
              const badge = item.badgeKey ? badges[item.badgeKey] : 0;
              return (
                <NavLink
                  key={`${group.label}-${item.label}`}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) => `wb-nav-link ${isActive ? 'active' : ''}`}
                >
                  <span className="wb-nav-icon"><item.icon size={16} /></span>
                  <span className="wb-nav-label">{item.label}</span>
                  {badge ? <span className="wb-nav-badge">{badge > 99 ? '99+' : badge}</span> : null}
                </NavLink>
              );
            })}
          </div>
        ))}
      </nav>
    </aside>
  );
}
